<div class="wrapper">
  <div class="row justify-content-center">
    <div class="col-lg-6">

      <div class="card-box">

        <div class="text-center w-75 m-auto">
          <a href="index.html">
            <span><img src="assets/images/acs_logo.png" alt="" height="100"></span>
          </a>
        </div>

        <h4 class="header-title">Forgot password</h4>
        <div class="form-group mb-3" *ngIf="error">
          <ngb-alert type="danger" [dismissible]="false">
            <strong>Error!</strong> {{errorMessage}}
          </ngb-alert>
        </div>


        <div class="form-group">
          <label for="email">Email address</label>
          <input [(formControl)]="emailAddress" [(ngModel)]="email" class="form-control" type="email" id="email" required="" placeholder="Enter your email">
          <ul *ngIf="submitted && required" class="parsley-errors-list filled">
            <li *ngIf="required" class="parsley-required">Email is required.</li>
          </ul>
        </div>
        <div class="form-group mb-0 justify-content-end row">
          <button type="button" class="btn btn-info waves-effect waves-light float-left m-2" (click)="goBack()">
             < Back
          </button>
          <button (click)="forgotPassword()" class="btn btn-gradient waves-effect waves-light float-left m-2" type="submit">Submit</button>
        </div>
        <br />

      </div> <!-- end card-box -->
    </div>
  </div>
</div>

